import { Component, computed, inject, input, output, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { SkeletonModule } from 'primeng/skeleton';
import { ButtonModule } from 'primeng/button';
import { AuthService } from '../../../services/auth/auth.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'dashboard-sidebar',
  imports: [
    CommonModule,
    NgOptimizedImage,
    SkeletonModule,
    ButtonModule,
    RouterLink,
    RouterLinkActive,
  ],
  templateUrl: './sidebar.component.html',
})
export class SidebarComponent {
  currentYear: number = new Date().getFullYear();
  isLoadingYYCLogo = true;
  isLoadingDashboardIcon = true;
  isLoadingFileIcon = true;
  isCollapsed = signal<boolean>(false);
  shouldShowText = signal<boolean>(true);
  sidebarWidth = output<boolean>();
  authService = inject(AuthService);
  canManageUsers = computed(() => this.authService.canManageUsers());
  canUseConversions = computed(() => this.authService.canUseConversions());
  isDevelopmentEnv = environment.env === 'development';

  // Mobile sidebar state - controlled by parent (main-layout)
  isMobileOpen = input<boolean>(false);
  mobileToggle = output<void>();

  // Effective collapsed state - always expanded in mobile view
  effectiveIsCollapsed = computed(() => {
    // In mobile view, always show expanded sidebar
    if (this.isMobileOpen()) {
      return false;
    }
    return this.isCollapsed();
  });

  toggleSidebar() {
    this.isCollapsed.set(!this.isCollapsed());
    this.sidebarWidth.emit(this.isCollapsed());
  }

  closeMobileSidebar() {
    this.mobileToggle.emit();
  }
}
